export default function Footer() {
  const handleAnchor = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">

          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-2-line text-xl text-primary-400"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">星空电影网</span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed mb-4">
              高清免费在线观影平台。涵盖最新电影、热门电影、动作片、喜剧片等丰富分类，找片看片一站搞定，畅享高清观影体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); handleAnchor('#ranking'); }}
                className="hover:text-primary-400 transition-colors"
              >
                快速入口
              </a>
            </h4>
            <ul className="space-y-2.5 text-sm text-background-300">
              <li><a href="#ranking" onClick={(e) => { e.preventDefault(); handleAnchor('#ranking'); }} className="hover:text-primary-400 transition-colors">本周热映</a></li>
              <li><a href="#index" onClick={(e) => { e.preventDefault(); handleAnchor('#index'); }} className="hover:text-primary-400 transition-colors">分类索引</a></li>
              <li><a href="#carousel" onClick={(e) => { e.preventDefault(); handleAnchor('#carousel'); }} className="hover:text-primary-400 transition-colors">专题推荐</a></li>
              <li><a href="#updates" onClick={(e) => { e.preventDefault(); handleAnchor('#updates'); }} className="hover:text-primary-400 transition-colors">最新快讯</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2.5 text-sm text-background-300">
              <li><span className="cursor-pointer hover:text-primary-400 transition-colors">动作片</span></li>
              <li><span className="cursor-pointer hover:text-primary-400 transition-colors">喜剧片</span></li>
              <li><span className="cursor-pointer hover:text-primary-400 transition-colors">科幻片</span></li>
              <li><span className="cursor-pointer hover:text-primary-400 transition-colors">悬疑片</span></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-400">优质合作伙伴持续邀请中</p>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; 2020-2026 星空电影网 xingkongmovie.com · 本站所有内容仅供学习交流
          </p>
          <div className="flex items-center gap-4 text-xs text-background-400">
            <span className="cursor-pointer hover:text-primary-400 transition-colors">服务条款</span>
            <span className="cursor-pointer hover:text-primary-400 transition-colors">隐私政策</span>
            <span className="cursor-pointer hover:text-primary-400 transition-colors">版权声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}